var $ = require("jquery");

var PassageTile = require("components/cloze/PassageTile.js")
require("cloze/passage.scss");
class Passage extends React.Component {
	constructor(props) {
		super();
		this.state = {
			selectedIndex: null, completions: {},
			footerFixed: false			
		};

		this.stickyWrap = React.createRef();
		this.stickyFooter = React.createRef();
		this.updateStickyPosition = this.updateStickyPosition.bind(this);
		this.onComplete = this.onComplete.bind(this);
	}

	selectClozeItem(clozeIndex, e) {
		if (e) { e.preventDefault() }
		this.setState({ selectedIndex: clozeIndex }, this.updateStickyPosition);
	}

	isComplete() {
		var isComplete = true;
		_.each(this.props.passage.clozes, (clozeData) => {
			isComplete = isComplete && (clozeData.clozeItemNumber in this.state.completions);
		});
		return isComplete;
	}

	onComplete() {
		var completionData = _.map(this.props.passage.clozes, (clozeData) => {
			return {
				clozeItemNumber: clozeData.clozeItemNumber,
				answer: this.state.completions[clozeData.clozeItemNumber]
			}
		});
		this.props.onPassageComplete(completionData);
	}

	setClozeCompletion(word, e) {
		if (e) { e.preventDefault() }
		var newCompletions = _.clone(this.state.completions)
		newCompletions[this.state.selectedIndex] = word;
		this.setState({ completions: newCompletions });
	}

	insertClozeSelectors(text) {
		var parts = text.split("__||__");
		var output = [];
		// Odd indexes will be for clozeIndexes
		_.map(parts, (item, index) => {
			if (index % 2 == 0) {
				output.push(handleWeirdFormatting(item));
			} else {
				var clozeIndex = parseInt(item);
				var showText = this.state.completions[clozeIndex] || clozeIndex;
				var className = "clozeItem";
				if (this.state.selectedIndex == clozeIndex) { 
					className += " selected";
				}
				if (clozeIndex in this.state.completions) { 
					className += " completed";
				}
				output.push(
					<a href="#" className={ className } key={ "cloze" + clozeIndex }
						onClick={ this.selectClozeItem.bind(this, clozeIndex) }>
						{ showText }
					</a>
				);
			}
		});

		return output;
	}

	getPassageContents() {
		var body = stripSpanTags(decodeHtml(this.props.passage.body));
		var paragraphs = _.map(toParagraphs(body), (text, index) => {
			if (text == SECTION_BREAK_MARK) {
				return (<hr />);
			} else {
				return (
					<p key={ index }>{ this.insertClozeSelectors(text) }</p>
				)				
			}
		});

		return (
			<div className="passageContents">
				{ paragraphs }
			</div>
		)
	}

	renderClozeControls() {
		if (this.state.selectedIndex === null) {
			return null;
		}
		var className = "clozeControls";
		if (this.state.footerFixed) {
			className += " fixed";
		}

		// We need to switch from one-indexed to zero-indexed
		var options = this.props.passage.clozes[this.state.selectedIndex - 1].clozeItems; 
		var optionSelectors = _.map(options, (word) => {
			var opClassName = "bubbleOp";
			if (this.state.completions[this.state.selectedIndex] === word) {
				opClassName += " selected";
			}
			return (
				<a href="#" key={ word } className={ opClassName }
					onClick={ this.setClozeCompletion.bind(this, word) }>
					{ word }
				</a>

			);
		});

		if (this.isComplete()) {
			// Gives is a className which will mean something with the WR codebase... maybe not ideal
			var completeDisplay = (
				<span className="completeDisplay">
					<button className="finishedButton" onClick={ this.onComplete }>
						Finish
					</button>
				</span>
			);
		}

		return (
			<div className={ className } ref={ this.stickyFooter }>
				<div className="inner">
					<div className="content">
						{ optionSelectors }
						{ completeDisplay }
					</div>
				</div>
			</div>
		);
	}

	render() {
		var passage = this.props.passage;
		var summary = "";
		return (
			<div className="Cloze-Passage">
				<div className="passageHeader">
					<PassageTile title={ passage.title }
						subCategoryName={ this.props.subCategoryName } getIcon={ this.props.getIcon }						
						categoryName={ this.props.categoryName } />
					<div className="summary">{ summary }</div>

					<div className="instructions">
						<div>Here's how to complete the challenge:</div>
						<ol>
							<li>Read the text</li>
							<li>Click on the missing words as you find them</li>
							<li>Choose the word that best completes the sentence</li>
						</ol>
					</div>
				</div>

				<div className="passageWrap" ref={ this.stickyWrap }>
					{ this.getPassageContents() }
					{ this.renderClozeControls() }
				</div>
			</div>
		);
	}

	componentDidMount() {
		$(window).on("scroll", this.updateStickyPosition);
		$(window).on("resize", this.updateStickyPosition);
	}

	componentWillUnmount() {
		$(window).off("scroll", this.updateStickyPosition);
		$(window).off("resize", this.updateStickyPosition);
	}

	updateStickyPosition() {
		if (this.state.selectedIndex === null) { return; }
		var $wrap = $(this.stickyWrap.current);
		var $footer = $(this.stickyFooter.current);
		var windowHeight = $(window).height();
		var wrapHeight = $wrap.height();
		var footerPadding = $footer.height() + 100;

		var windowTopOffest = $(window).scrollTop()
		var wrapTopOffset = $wrap.offset().top;

		var footerOffset = (wrapTopOffset + wrapHeight) - (windowHeight + windowTopOffest);
		if (footerOffset > 0 && (footerOffset + footerPadding) < wrapHeight) {
			this.setState({ footerFixed: true });

			// Also, we need to set the width, which is normally determined by this
			// component's parent's width
			if ($footer.length > 0) {
				$footer.find(".inner").css("width", $wrap.width())
			}

		} else {
			this.setState({ footerFixed: false });
		}
	}

}

var ATTEMPT_BREAK_LENGTH = 100;
var SENT_END_REGEX = /^[\.\?\!]\"?\s+([A-Z]|\")/;

// Webpack don't like the raw regex
var TITLE_REGEX = /\s(m|d)(r|i)?i?(r|s)\./gi;

function toParagraphs(text) {
	if (text.indexOf(LINE_BREAK_MARK) == -1) {
		// Use the fallback 
		return oldToPragraphs(text);
	}

	var lines = [];

	_.each(text.split(SECTION_BREAK_MARK), function(section, index) {
		if (index != 0) {
			lines.push(SECTION_BREAK_MARK);
		}
		_.each(section.split(LINE_BREAK_MARK), function(paragraph, index) {
			lines.push(paragraph.trim());
		});
	});

	return lines;
}

// From before TR was providing paragraph breaks
// Soon to be remove completely
function oldToPragraphs(text) {
	var paragraphs = [];
	var lastBreak = 0;
	var inQuote = false;

	for (var index = 1; index < text.length; index += 1) {
		var textFromIndex = text.substring(index - 1);

		if (textFromIndex.startsWith(SECTION_BREAK_MARK)) {
			paragraphs.push(text.substring(lastBreak, index - 1).trim());
			paragraphs.push(SECTION_BREAK_MARK);

			index += SECTION_BREAK_MARK.length - 1;
			lastBreak = index;

			inQuote = false;
			continue;
		}

		// If we're at the end of a quote ending with a period
		if (inQuote && SENT_END_REGEX.test(textFromIndex) && text[index] == '"') {
			paragraphs.push(text.substring(lastBreak, index + 1).trim());
			lastBreak = index + 1;
			inQuote = false;
			continue;
		}

		if (text[index] == '"') {
			if (text[index + 1] == '"') {
				paragraphs.push(text.substring(lastBreak, index + 1).trim());
				lastBreak = index + 1;
				index += 1;
				inQuote = true;
				continue;

			} else {
				inQuote = !inQuote;				
			}
		}

		if (!inQuote && SENT_END_REGEX.test(textFromIndex) && (index - lastBreak > ATTEMPT_BREAK_LENGTH)) {
			var titleText = text.substring(index - 5, index + 1);
			if (!TITLE_REGEX.test(titleText)) {
				paragraphs.push(text.substring(lastBreak, index + 1).trim());
				lastBreak = index + 1;
				continue;
			}
		}
	}
	if (lastBreak < text.length) {
		paragraphs.push(text.substring(lastBreak).trim());
	}
	return paragraphs;
}

var OTHER_REPLACEMENTS = [
	[/&quot;/g, '"'],
	[/&apos;/g, "'"],
	[/&nbsp;/g, " "],
]
var SECTION_BREAK_REGEX = /<P ALIGN(\w| |=|"|#)*>/g; // Only care about the close ones
var SECTION_BREAK_MARK = "|-|SectionBreak|-|";

var LINE_BREAK_REGEX = /(<\/?br>)+/g;
var LINE_BREAK_MARK = "|-|LineBreak|-|";

var JUNK_HTML_REGEX = /<\/?[A-Z](\w| |=|"|#)*>/g;

function decodeHtml(content) {
	// Thanks @ Rob W
	// https://stackoverflow.com/a/7394787/4557470
	var textarea = document.createElement("textarea");
	textarea.innerHTML = content;

	var formattedContent = textarea.value;

	formattedContent = formattedContent.replace(LINE_BREAK_REGEX, LINE_BREAK_MARK)
	formattedContent = formattedContent.replace(SECTION_BREAK_REGEX, SECTION_BREAK_MARK)

	_.each(OTHER_REPLACEMENTS, (pair) => {
		formattedContent = formattedContent.replace(pair[0], pair[1]);
	});

	if (JUNK_HTML_REGEX.test(formattedContent)) {
		formattedContent = formattedContent.replace(JUNK_HTML_REGEX, " ");
	}

	return formattedContent;
}

var ITALICS_REGEX = /<\/?i>/g;
var PARAGRAPH_REGEX = /<\/?(p|br)>/g;
var ESCAPED_QUOTE_REGEX = /\\'/g;

function handleWeirdFormatting(content) {
	// We're inserting our own line breaks, so ignore these....
	if (PARAGRAPH_REGEX.test(content)) {
		var strippedText = content.replace(PARAGRAPH_REGEX, " ");
		return handleWeirdFormatting(strippedText);
	}

	if (ESCAPED_QUOTE_REGEX.test(content)) {
		var strippedText = content.replace(ESCAPED_QUOTE_REGEX, "'");
		return handleWeirdFormatting(strippedText);
	}

	if (ITALICS_REGEX.test(content)) {
		var emParts = content.split(ITALICS_REGEX);
		// Odd indexes will be for clozeIndexes
		var formattedParts = _.map(emParts, (item, index) => {
			if (index % 2 == 0) {
				return handleWeirdFormatting(item);
			} else {
				return (
					<em key={ index }>{ item }</em>
				);
			}
		});
		return formattedParts;
	}

	return content;
}


var OPEN_SPAN_REGEX = /<span[ \w_\"\'=]*>/g;
var CLOSE_SPAN_REGEX = /<\/span[ \w_\"\'=]*>/g;
function stripSpanTags(content) {
	return content.replace(OPEN_SPAN_REGEX, "__||").replace(CLOSE_SPAN_REGEX, "||__");
}


Passage.propTypes = {
	passage: PropTypes.object.isRequired,
	onPassageComplete: PropTypes.func.isRequired,
	subCategoryName: PropTypes.string,
	categoryName: PropTypes.string,
	getIcon: PropTypes.func
}

module.exports = Passage;


// WEBPACK FOOTER //
// ./modules/components/cloze/Passage.js